import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { isCatex, isSod, priceParser, getItemSavingAmount } from '../../Helpers'

import TLBciPrice from './components/TLBciPrice'
import WlmPrice from '../ProductPrices/components/WlmPrice'
import PricePerUm from './components/PricePerUm'
import Price from './components/Price'
import SavingsLabel from '../SavingsLabel'

const ProductPricesMobile = ({ price, discount, soldByWeight, price: { BasePricePerUm } }) => {
  const BasePriceSales = priceParser(price.BasePriceSales)
  const BasePriceReference = priceParser(price.BasePriceReference)
  const BasePriceTLMC = priceParser(price.BasePriceTLMC)
  const wlmPrice = BasePriceSales > 0 ? BasePriceSales : BasePriceReference
  const shouldDisplayTLMC = isCatex() && BasePriceTLMC > 0
  const shouldDisplaySaving = BasePriceSales > 0 && BasePriceReference > BasePriceSales
  const shouldDisplayUm = isSod() && BasePricePerUm && BasePricePerUm !== '0' && soldByWeight && soldByWeight == 'true'

  const showSodSavingsLabel = isSod() && discount > 0

  return (
    <Fragment>
      {shouldDisplayTLMC && (
        <TLBciPrice
          price={BasePriceTLMC}
          imgClass="tlbci-price__img__pdp--mobile"
          textClass="pdp-mobile-pay-not-tlmc"
        />
      )}
      <WlmPrice price={wlmPrice} discount={discount} textClass="pdp-mobile-pay-not-tlmc">
        {showSodSavingsLabel && <SavingsLabel savings={getItemSavingAmount(price)} classNames="ml-2" />}
      </WlmPrice>
      {!shouldDisplayTLMC && shouldDisplaySaving && <Price price={BasePriceReference} className="saving__price__pdp" />}
      {shouldDisplayUm && (
        <PricePerUm price={BasePricePerUm} priceClass="price-per-um__pdp price-per-um__pdp--mobile" />
      )}
    </Fragment>
  )
}

ProductPricesMobile.propTypes = {
  price: PropTypes.object.isRequired,
  discount: PropTypes.number,
  soldByWeight: PropTypes.string,
}

ProductPricesMobile.defaultProps = {
  discount: 0,
  soldByWeight: 'false',
}

export default ProductPricesMobile
